import { isSafari } from 'react-device-detect'
import { Overrides } from '@material-ui/core/styles/overrides'
import { MuiPickersOverrides } from '@material-ui/pickers/typings/overrides'
import Palette from './palette'
import spacing from './spacing'

const overrides: Overrides & MuiPickersOverrides = {
  MuiButton: {
    root: {
      borderRadius: 10,
      whiteSpace: 'nowrap',
      textTransform: 'none',
    },
    startIcon: {
      marginLeft: 0,
      marginRight: 0,
    },
    contained: {
      color: Palette.common.white,
      backgroundColor: Palette.primary.main,
      '&:hover': {
        backgroundColor: Palette.primary.dark,
      },
    },
    outlined: {
      color: Palette.primary.main,
      borderColor: Palette.primary.main,
    },
    text: {
      color: Palette.primary.main,
    },
  },
  MuiPickersCalendar: {
    transitionContainer: {
      marginBottom: 10,
    },
  },
  MuiIconButton: {
    root: {
      borderRadius: 10,
      color: 'inherit',
    },
  },
  MuiInput: {
    underline: {
      '&:hover:not(.Mui-disabled):before': {
        borderBottom: `2px solid ${Palette.primary.main}`,
      },
    },
  },
  MuiTooltip: {
    tooltip: {
      backgroundColor: Palette.secondary.dark,
      margin: 0,
      ...(isSafari && {
        transitionDuration: '0s !important',
      }),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: spacing(1, 2),
      boxSizing: 'border-box',
      borderRadius: 10,
      fontSize: 12,
    },
  },
  MuiInputBase: {
    root: {
      borderRadius: 10,
      backgroundColor: Palette.common.white,
      transitionDuration: '0.3s',
      transitionProperty: 'background-color',
      '& fieldset legend span': {
        display: 'none',
      },
      '& input': {
        boxShadow: 'none',
      },
      '&.Mui-error': {
        backgroundColor: Palette.error.light,
      },
    },
    input: {
      WebkitBoxShadow: `0 0 0 1000px ${Palette.common.white} inset`,
      padding: '10px 15px',
    },
  },
  MuiSelect: {
    root: {
      borderRadius: 10,
      backgroundColor: Palette.common.white,
    },
    select: {
      '&:focus': {
        backgroundColor: Palette.common.white,
      },
    },
    outlined: {
      '& em': {
        fontStyle: 'normal',
        color: Palette.text.disabled,
      },
    },
  },
  MuiOutlinedInput: {
    root: {
      borderRadius: 10,
      borderWidth: 0.5,
      borderColor: Palette.text.disabled,
      '& > fieldset:last-child': {
        transitionProperty: 'border-color',
        transitionDuration: '0.3s',
      },
      '&:not(.Mui-error):not(.Mui-disabled):hover > fieldset:last-child': {
        borderColor: Palette.primary.main,
      },
    },
    input: {
      padding: '10px 15px',
      boxSizing: 'border-box',
    },
  },
  MuiList: {
    root: {
      borderRadius: 10,
    },
    padding: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  MuiMenu: {
    paper: {
      borderRadius: 10,
    },
  },
  MuiListItemText: {
    root: {
      lineHeight: '14px',
    },
  },
  MuiListItem: {
    root: {
      paddingLeft: 15,
      paddingRight: 15,
      height: 48,
    },
  },
  MuiFormLabel: {
    root: {
      color: Palette.primary.main,
      fontSize: 12,
      lineHeight: '12px',
      paddingLeft: 2,
      marginBottom: 4,
    },
  },
  MuiInputLabel: {
    formControl: {
      position: 'relative',
      top: 'initial',
      left: 'initial',
    },
    outlined: {
      '&.MuiInputLabel-shrink': {
        transform: 'none',
      },
      transform: 'none',
    },
  },
  MuiPaper: {
    rounded: {
      borderRadius: 20,
    },
    elevation1: {
      zIndex: 99,
    },
  },
  MuiBackdrop: {
    root: {
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
    },
  },
  MuiTab: {
    root: {
      fontSize: 14,
      lineHeight: '16px',
    },
    textColorPrimary: {
      '&.Mui-selected': {
        fontWeight: 700,
      },
    },
  },
  MuiSwitch: {
    root: {
      padding: 0,
      width: 38,
      height: 20,
    },
    thumb: {
      width: 16,
      height: 16,
      backgroundColor: Palette.common.white,
    },
    switchBase: {
      padding: 2,
      '&$checked': {
        transform: 'translateX(18px)',
        '& + $track': {
          opacity: 1,
          border: `2px solid ${Palette.success.main}`,
          backgroundColor: Palette.success.main,
        },
      },
    },
    track: {
      borderRadius: 26 / 2,
      border: `2px solid ${Palette.text.disabled}`,
      backgroundColor: Palette.text.disabled,
      opacity: 1,
    },
    colorSecondary: {
      '&$checked': {
        '& + $track': {
          backgroundColor: Palette.success.main,
        },
      },
    },
    checked: {},
  },
  MuiPopover: {
    root: {
      ...(isSafari && {
        transitionDuration: '0s !important',
        '& *': {
          transitionDuration: '0s !important',
        },
      }),
    },
  },
}

export default overrides
